export default function renewalLapseReasons() {
  return [
    { label: 'Not known', value: 'Not known' },
    // { label: 'Other', value: false },
  ];
}
